export enum DcpApiPlatforms {
  KYMA = 'kyma',
  API = 'api',
}
